module.exports = __webpack_public_path__ + "img/free_multiplier_6.a4d158b6.png";